<template>
   <div class="card">
      <div class="card-body m-2">
         <div class="row p-2 align-items-center">

            <!-- Search + Add Button -->
            <div class="col-12 col-lg-4 mb-2 mb-lg-0 d-flex gap-2">
               <input v-model="inputKey" type="text" class="form-control form-control-sm"
                  placeholder="&#xF002; Add/Search Extension Key..."
                  style="border-radius:8px; height: 40px; font-size: 14px; font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free'; font-weight: 900;"
                  @keyup="onSearch()" v-on:keyup.enter="onEnter" ref="api_key_ref" />
            </div>

            <div class="col-12 col-lg-auto d-flex mb-2 mb-lg-0 gap-2">
               <button type="button" class="fw-bold btn text-light btn-sm"
                  style="font-size: 14px; height: 40px; border-radius: 8px !important; padding: 0 1.5rem; white-space: nowrap; background: #00a0c1;"
                  @click="sendData">
                  <i class="fa-solid fa-plus-circle me-1"></i> Add Extension Key
               </button>
            </div>

            <!-- Filters + Pagination -->
            <div class="col-12 col-lg d-flex flex-wrap justify-content-lg-end align-items-center">

               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Sort by:</span>
                  <select v-model="sortBy" class="form-select shadow-none filterOptions bordered-select">
                     <option v-for="s in sortByList" :value="s.value" :key="s.value">{{ s.text }}</option>
                  </select>
               </div>

               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Rows per page:</span>
                  <select v-model="pagination.pageSize"
                     class="form-select form-select-sm shadow-none filterOptions bordered-select" style="width: auto;">
                     <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}</option>
                  </select>
               </div>

               <div class="pagination" v-if="pagination.totalItems > 0">
                  <button @click="previousPage()" :disabled="pagination.page == 1" class="pagination-arrow">
                     <i class="fa fa-chevron-left"></i>
                  </button>
                  <span class="pagination-label">
                     <strong>{{ paginationLabel }}</strong> of {{ pagination.totalItems }}
                  </span>
                  <button @click="nextPage()"
                     :disabled="pagination.page == pagination.totalPages || pagination.totalItems == 0"
                     class="pagination-arrow">
                     <i class="fa fa-chevron-right"></i>
                  </button>
               </div>

            </div>
         </div>

         <!-- Table -->
         <div class="row p-2">
            <table class="table align-middle mainTable">
               <thead class="align-middle">
                  <tr>
                     <th scope="col" v-for="header in filteredHeaders" :key="header.value">{{ header.text }}</th>
                  </tr>
               </thead>

               <tbody v-if="pagination.totalItems <= 0">
                  <tr>
                     <td colspan="6">No records to display.</td>
                  </tr>
               </tbody>

               <tbody v-else>
                  <tr v-for="(extensionKey, index) in extensionKeys" :key="index">
                     <td>{{ extensionKey.name || '—' }}</td>
                     <td>{{ extensionKey.host_name || '—' }}</td>
                     <td style="font-family: monospace; font-size: 12px;">{{ extensionKey.api_key }}</td>
                     <td v-if="this.$store.state.auth.isSuperAdmin">{{ formatDate(extensionKey.date_created) }}</td>
                     <td v-if="this.$store.state.auth.isSuperAdmin">{{ formatDate(extensionKey.allocation_date) }}</td>
                     <td>
                        <div class="d-flex gap-2">
                           <button type="button" class="ms-action-btn ms-action-btn--edit"
                              
                              @click="SetIndex(index); showEditModal = true;" title="Edit Name">
                              <i class="fas fa-pen"></i>
                           </button>
                           <button type="button" class="ms-action-btn ms-action-btn--delete"
                              
                              @click="deleteExtensionKey(index)" title="Remove">
                              <i class="fa fa-xmark"></i>
                           </button>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>

   <!-- Edit Modal -->
   <div class="modal-backdrop-custom" v-if="showEditModal" @click.self="showEditModal = false">
      <div class="modal-content-custom">
         <button @click="showEditModal = false" class="close-button-custom">&times;</button>
         <h5 class="modal-title-custom">
            <i class="fa-solid fa-pen me-2" style="color: #00a0c1;"></i>
            Update Extension Name
         </h5>
         <hr>
         <div class="modal-body-custom">
            <label class="filter-label">Extension Name</label>
            <input type="text" class="form-control form-control-sm"
               style="border-radius: 8px;"
               v-model="inputName" v-on:keyup.enter="updateName(); showEditModal = false;">
         </div>
         <div class="modal-footer-custom">
            <button type="button" class="btn btn-sm btn-modal-cancel" @click="showEditModal = false">Cancel</button>
            <button type="button" class="btn btn-sm text-light" style="background: #00a0c1; border-radius: 8px;"
               @click="updateName(); showEditModal = false;">
               Update
            </button>
         </div>
      </div>
   </div>
</template>

<script>
import { debounce, extractErrorMessage } from '@/plugins/helper.js'
import moment from 'moment'
export default {

   components: {},

   data() {
      return {
         showEditModal: false,
         headers: [
            { text: "Name", value: "name" },
            { text: "Host Name", value: "host_name" },
            { text: "Extension Key", value: "api_key" },
            { text: "Creation Date", value: "date_created" },
            { text: "Allocation Date", value: "allocation_date" },
            { text: "Action", value: "action" },
         ],
         extensionKeys: [],
         inputKey: "",
         inputName: "",
         search: "",
         debounceFn: null,
         extensionNameIndex: null,
         paginationData: {},
         pagination: {
            pageSize: 50, page: 1, totalItems: 0, totalPages: 1,
         },
         rowsPerPageList: [
            { text: "50", value: 50 },
            { text: "75", value: 75 },
            { text: "100", value: 100 },
         ],
         sortByList: [
            { text: "Date: Newest", value: "date_created__desc" },
            { text: "Date: Oldest", value: "date_created__asc" },
         ],
         sortBy: "date_created__desc",
         sorting: { field: "date_created", order: "desc" },
      };
   },

   computed: {
      paginationLabel() {
         var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
         var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)
         return start + " - " + end
      },
      currentPage() { return this.pagination.page },
      rowsPerPage() { return this.pagination.pageSize },
      sortItems() { return this.sortBy },
      filteredHeaders() {
         return this.headers.filter(header => {
            if (this.$store.state.auth.isSuperAdmin) return true;
            return header.value !== 'date_created' && header.value !== 'allocation_date';
         });
      },
   },

   watch: {
      currentPage() { this.getExtensionKeys_() },
      rowsPerPage() { this.pagination.page = 1; this.getExtensionKeys_() },
      sortItems() {
         if (this.sortBy.includes("__")) {
            let sort = this.sortBy.split("__")
            this.sorting.field = sort[0]
            this.sorting.order = sort[1]
         } else {
            this.sorting.field = this.sortBy
            this.sorting.order = ""
         }
         this.getExtensionKeys_()
      },
   },

   mounted() { this.init(); },

   created() {
      this.debounceFn = debounce(() => this.getExtensionKeys_(), 500)
   },

   methods: {
      init() {
         this.getExtensionKeys_()
         const urlParams = new URLSearchParams(window.location.search);
         const apiKey = urlParams.get('api_key');
         if (apiKey !== "" && apiKey != null) {
            this.inputKey = apiKey
            this.focusInput()
         } else {
            this.unfocusInput()
         }
      },

      onEnter() { this.sendData() },
      onSearch() { this.debounceFn(); this.pagination.page = 1 },
      focusInput() { this.$refs.api_key_ref.focus(); },
      unfocusInput() { this.$refs.api_key_ref.blur(); },
      previousPage() { this.pagination.page > 1 ? this.pagination.page -= 1 : '' },
      nextPage() { this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : '' },

      async getExtensionKeys_() {
         let apiPath = "extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-extension-keys-v2?page_size=" + this.pagination.pageSize + "&page=" + this.pagination.page
         if (this.sorting.order != "") { apiPath += "&order_by=" + this.sorting.order }
         if (this.search !== "" || this.search !== null) { apiPath += "&api_key=" + this.inputKey }

         await this.$axios.get(apiPath)
            .then((response) => {
               if (response.data.api_keys === "No Record Found") this.extensionKeys = []
               else { this.extensionKeys = response.data.api_keys }
               this.paginationData = response.data.pagination
               this.pagination.totalItems = this.paginationData.total_count
               this.pagination.totalPages = Math.ceil(this.paginationData.total_count / this.pagination.pageSize)
            })
            .catch((error) => { this.$toast.error(extractErrorMessage(error, "Failed to load extension keys.")) })
      },

      async sendData() {
         try {
            if (this.inputKey == "" || this.inputKey == null || this.is64CharacterAlphanumeric(this.inputKey) == false) {
               this.$toast.error("Please provide a valid extension key"); return
            }
            const payload = { api_key: this.inputKey }
            const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/allocate-extension-key", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
            }
            this.inputKey = ""; this.getExtensionKeys_()
         } catch (error) {
            this.$toast.error(extractErrorMessage(error, "Failed to allocate extension key."))
            this.inputKey = ""; this.getExtensionKeys_()
         }
      },

      async deleteExtensionKey(index) {
         try {
            const payload = { api_key: this.extensionKeys[index].api_key, id: this.extensionKeys[index].id }
            const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/unallocate-extension-key", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getExtensionKeys_()
            }
         } catch (error) {
            this.$toast.error(extractErrorMessage(error, "Failed to unallocate extension key."))
         }
      },

      is64CharacterAlphanumeric(input) {
         if (typeof input !== 'string' || input.length !== 64) return false;
         return /^[a-zA-Z0-9]+$/.test(input);
      },

      async updateName() {
         try {
            let iName = null
            if (this.inputName !== "") { iName = this.inputName }
            const payload = {
               name: iName,
               id: this.extensionKeys[this.extensionNameIndex].id,
               api_key: this.extensionKeys[this.extensionNameIndex].api_key
            }
            const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-extension-name", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getExtensionKeys_()
            }
         } catch (error) {
            console.log(error); this.$toast.error(extractErrorMessage(error, "Failed to update extension name."))
         }
      },

      SetIndex(index) {
         this.extensionNameIndex = index
         this.inputName = this.extensionKeys[index].name
      },

      formatDate(date) { return moment(date).format("DD-MMM-YYYY @ HH:mm:ss") }
   }
}
</script>

<style scoped>
.card { border: none; }

.btn-outline-info {
   color: #00A0C1;
   border-color: #00A0C1;
}
.btn-outline-info:hover {
   color: #fff;
   background-color: #00A0C1;
   border-color: #00A0C1;
}

/* Modal */
.modal-backdrop-custom {
   position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
   background-color: rgba(0,0,0,0.5); display: flex;
   justify-content: center; align-items: center; z-index: 1050;
}
.modal-content-custom {
   position: relative; background: #fff; padding: 2rem;
   border-radius: 14px; width: 100%; max-width: 460px;
   box-shadow: 0 8px 30px rgba(0,0,0,0.2);
}
.modal-title-custom { font-weight: 700; font-size: 1.1rem; color: #435666; margin-bottom: 0; }
.modal-content-custom hr { margin: 0.75rem 0 1rem; border-color: #e9ecef; }
.close-button-custom {
   position: absolute; top: 0.75rem; right: 1rem;
   font-size: 1.8rem; font-weight: bold; line-height: 1;
   color: #adb5bd; background: none; border: none; cursor: pointer;
}
.close-button-custom:hover { color: #435666; }
.modal-body-custom { font-size: 14px; color: #435666; }
.filter-label {
   font-size: 11px; font-weight: 600; color: #6c757d;
   text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 4px;
}
.modal-footer-custom { margin-top: 1rem; display: flex; justify-content: flex-end; gap: 8px; }
.btn-modal-cancel { background: #e9ecef; border: none; border-radius: 8px; color: #435666; }
</style>